// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import datatable from '../datatable'
import { farms$, fields$ } from 'fc-assets'
import { jobs$ } from 'hfty-soil-jobs'
import { crops$ } from 'fc-model-crops'
import { currentUserUnits$ } from 'hfty-users'
import { routerQuery$ } from 'hfty-navigation-web'
import fertilizers$ from 'hfty-fertilizers/src/selectors/fertilizers'

// Operator
import recommendationsOperator from 'hfty-operator-recommendations'

// Actions
import {
  fetchRecommendations,
  fetchRecommendationById,
  fetchHeftyCrops,
  removeRecommendation,
  operations$,
} from 'hfty-recommendations'
import { fetchFertilizers } from 'hfty-fertilizers'

// Types
import type { Asset } from 'fc-model-assets/types'
import type { SoilJob } from 'hfty-model-soil-jobs/types'
import type { RecommendationOperationsById } from 'hfty-operator-recommendations/types'
import type { Crop } from 'fc-model-crops/types'
import type { Fertilizer } from 'fc-model-fertilizers/types'

// Props type
type Props = {
  selectedIds: Array<number>,
  farms: Array<Asset>,
  fields: Array<Asset>,
  jobs: Array<SoilJob>,
  crops: Array<Crop>,
  currentUserUnits: string,
  operations: RecommendationOperationsById,
  fertilizers: Array<Fertilizer>,
}

function mapStateToProps (state: Object): Props {
  return {
    selectedIds: datatable.selectors.selectedRecordIds$(state),
    farms: farms$(state),
    fields: fields$(state),
    jobs: jobs$(state),
    crops: crops$(state),
    operations: operations$(state),
    currentUserUnits: currentUserUnits$(state),
    routerQuery: routerQuery$(state),
    fertilizers: fertilizers$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    fetchRecommendations: Function,
    fetchRecommendationById: Function,
    removeRecommendation: Function,
    onCancelOperations: Function,
    onSubmitOperations: Function,
    fetchHeftyCrops: Function,
    fetchFertilizers: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      fetchRecommendations: fetchRecommendations,
      fetchRecommendationById: fetchRecommendationById,
      removeRecommendation: removeRecommendation,
      onCancelOperations: recommendationsOperator.actionCreators.cancelOperations,
      onSubmitOperations: recommendationsOperator.actionCreators.submitOperations,
      fetchHeftyCrops: fetchHeftyCrops,
      fetchFertilizers,
    }, dispatch),
  }
}

// Export
export default connect(mapStateToProps, mapDispatchToProps)
